/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { isApolloError } from 'apollo-client';
import { fireErrorAnalyticsCommon } from '@jira/issue__commmon-error-boundary/src/fireErrorAnalyticsCommon.tsx';
import type { AnalyticsPayload } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { handleApolloError } from '../handle-apollo-error/index.tsx';

export const fireIssueCreateErrorAnalytics = (payload: AnalyticsPayload): void => {
	const { attributes = {}, error, ...otherPayload } = payload;

	fireErrorAnalyticsCommon({
		...otherPayload,
		attributes: {
			...attributes,
			...(error && isApolloError(error) ? { errorType: handleApolloError(error) } : {}),
		},
		error,
	});
};
